import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './App.less';
import i18n from './i18n';
import { Provider } from 'react-redux';
import { store } from './store';
import numeral from 'numeral';
import { ConfigProvider, theme } from 'antd';
import es_ES from 'antd/lib/locale/es_ES';
import ca_ES from 'antd/lib/locale/ca_ES';
import en_GB from 'antd/lib/locale/en_GB';
import 'moment/locale/es';
import 'moment/locale/ca';
import 'moment/locale/en-gb';
import { FirebaseAnalytics } from './Firebase';
import { AnalyticsProvider } from 'use-analytics';
import Analytics from 'analytics';
import mixpanelPlugin from '@analytics/mixpanel';
import amplitudePlugin from '@analytics/amplitude';
import { BrowserRouter } from 'react-router-dom';

let locale = es_ES;
const locales = {
	es: es_ES,
	cat: ca_ES,
	en: en_GB
};

i18n.on('languageChanged', function (lang) {
	locale = locales[lang];
});

numeral.register('locale', 'es', {
	delimiters: {
		thousands: '.',
		decimal: ','
	},
	abbreviations: {
		thousand: 'k',
		million: 'm',
		billion: 'b',
		trillion: 't'
	},
	ordinalIgnore: function (number) {
		return number === 1 ? 'er' : 'ème';
	},
	currency: {
		symbol: '€'
	}
});

numeral.locale('es');

/* Sentry.init({
	dsn: 'https://ff172221d5804b54b44fe6e95376c920@o440063.ingest.sentry.io/4504605470818304',
	integrations: [new BrowserTracing()],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0
}); */

const analytics = Analytics({
	app: 'gibobs-app',
	plugins: [
		amplitudePlugin({
			apiKey: '5ebdb450ade7d9501e2c1b370648c9f4',
			options: {
				trackingOptions: {
					ip_address: true
				}
			}
		}),
		mixpanelPlugin({
			token: '0183902a8eaf90dd010d79680f450ea9'
		})
	]
});

ReactDOM.render(
	<React.StrictMode>
		<ConfigProvider
			locale={locale}
			theme={{
				algorithm: theme.defaultAlgorithm,
				token: { colorPrimary: '#006DFF', colorBgLayout: 'white' }
			}}>
			<AnalyticsProvider instance={analytics}>
				<Provider store={store}>
					<Suspense fallback="loading">
						{/* <FirebaseAnalytics /> */}
						<BrowserRouter>
						<App />
						</BrowserRouter>
						
					</Suspense>
				</Provider>
			</AnalyticsProvider>
		</ConfigProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
